import React from "react";
import CommonGrid from "./CommonGrid";
import { ColumnType } from "../../../../components/Grid/constants";
import { FilterOperation } from "../../../../components/Grid/dataProvider";
import {FormattedDate} from "react-intl";
// import { FormattedDate } from 'react-intl';

export default (props) => {
  const columns = [
    {
      field: "created",
      displayField: "created",
      label: "Datum",
      type: ColumnType.DATE,
      width: "20%",
    },
    {
      field: "officialFullName",
      // displayField: "official",
      label: "Veřejný funkcionář",
      type: ColumnType.JSX,
      jsx: (row) => {
        if (!row.official) {
          return `Nenalezen (${row.requestData})`;
        }
        const { firstName, lastName, birthDate } = row.official;
        const [year, month, day] = birthDate.split('-');
        return `${firstName} ${lastName} (${day}.${month}.${year})`;
      },
      width: "20%",
    },
    {
      field: "reason",
      label: "Důvod nahlížení",
      type: ColumnType.TEXT,
      width: "20%",
      align: "left",
    },
    {
      field: "responseData",
      label: "Oznámení",
      type: ColumnType.TEXT,
      width: "20%",
      align: "left",
      sortable: false,
    },
    {
      field: "requesterInfo",
      label: "Zástupce finanční instituce",
      type: ColumnType.TEXT,
      width: "20%",
      align: "left",
      sortable: false,
    },
  ];

  const filters = [
    {
      field: "created",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
    // {
    //   field: "official",
    //   operation: FilterOperation.CONTAINS,
    //   value: "",
    // },
    {
      field: "reason",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
    {
      field: "requestData",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
    {
      field: "requesterInfo",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
  ];

  const pageSizeItems = [
    { id: 10, label: "10" },
    { id: 20, label: "20" },
    { id: 50, label: "50" },
    { id: 100, label: "100" },
  ];

  return (
    <CommonGrid
      {...props}
      columns={columns}
      pageSizeItems={pageSizeItems}
      filters={filters}
    />
  );
};

export const FinancialInstitutionsHistoryGrid = (props) => {
  const columns = [
    {
      field: "created",
      displayField: "created",
      label: "Datum",
      type: ColumnType.DATE,
      width: "20%",
    },
    {
      field: "officialFullName",
      // displayField: "official",
      label: "Veřejný funkcionář",
      type: ColumnType.JSX,
      jsx: (row) => {
        if (!row.official) {
          return `Nenalezen (${row.requestData})`;
        }
        const { firstName, lastName, birthDate } = row.official;
        const [year, month, day] = birthDate.split('-');
        return `${firstName} ${lastName} (${day}.${month}.${year})`;
      },
      width: "20%",
    },
    {
      field: "reason",
      label: "Důvod nahlížení",
      type: ColumnType.TEXT,
      width: "20%",
      align: "left",
    },
    {
      field: "responseData",
      label: "Oznámení",
      type: ColumnType.TEXT,
      width: "20%",
      align: "left",
      sortable: false,
    },
    {
      field: "requesterInfo",
      // zastupce fin. instituce
      label: "Zástupce finanční instituce",
      type: ColumnType.TEXT,
      width: "20%",
      align: "left",
      sortable: false,
    },
  ];

  const filters = [
    {
      field: "created",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
    // {
    //   field: "official",
    //   operation: FilterOperation.CONTAINS,
    //   value: "",
    // },
    {
      field: "reason",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
    {
      field: "requestData",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
    {
      field: "requesterInfo",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
  ];

  const pageSizeItems = [
    { id: 10, label: "10" },
    { id: 20, label: "20" },
    { id: 50, label: "50" },
    { id: 100, label: "100" },
  ];

  return (
    <CommonGrid
      {...props}
      columns={columns}
      pageSizeItems={pageSizeItems}
      filters={filters}
    />
  );
};
